module.exports = __webpack_public_path__ + "img/logo.5665da75.png";